export const MaxNumberOfSelectedFiles = 50;

export const MaxFileSize = 52428800; //in bytes

export const DragEventDataTransferType = "Files";

export const EmptyFileName = "file";

export const IconTextCommon = "FILE";

export const SieFileExtensions = [".se", ".si", ".sie"];

export const FileViewerFullScreenId = "fileViewerFullScreen";
export const DialogFilePreviewPortalId = "filePreviewRoot";
export const DialogContentFullScreenId = "DialogContentFullScreen";
export const DialogPreviewElementId = "dialogPreviewElement";

export const FileSizes = {
  TwoMB: 2097152,
};
